export default class Gateway {
  static get window() {
    return window;
  };

  static get isAutoV10() {
    return this.window.nd !== undefined && this.window.nd.auto !== undefined;
  }

  static autoRequire(modules, callback) {
    return this.window.nd.auto.require(modules, callback);
  }
};
